import React, { useState } from "react";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "/api";

const SAMPLE_PAYLOAD = {
  leads: [
    {
      external_source: "try_panel",
      external_id: "test-lead-001",
      owns_fields: ["status"],
      lead: {
        company: "Try Panel Dealership",
        email: "try@example.com",
        status: "Qualified",
        lead_source: "DFC",
      },
    },
  ],
};

function TryPanel({ apiInfo }) {
  const [apiKey, setApiKey] = useState("");
  const [payload, setPayload] = useState(JSON.stringify(SAMPLE_PAYLOAD, null, 2));
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  const send = async () => {
    setLoading(true);
    setResult(null);
    setError("");
    try {
      let parsed;
      try {
        parsed = JSON.parse(payload);
      } catch {
        throw new Error("Payload is not valid JSON");
      }

      const res = await axios.post(`${API_URL}/docs/sandbox/test-post`, parsed, {
        headers: { Authorization: `Bearer ${apiKey}` },
      });
      setResult(res.data);
    } catch (e) {
      setError(
        e?.response?.data?.message ||
          e?.response?.data?.error ||
          e.message ||
          "Request failed",
      );
    } finally {
      setLoading(false);
    }
  };

  const ping = async () => {
    setLoading(true);
    setResult(null);
    setError("");
    try {
      const res = await axios.post(
        `${API_URL}/docs/sandbox/ping`,
        {},
        { headers: { Authorization: `Bearer ${apiKey}` } },
      );
      setResult(res.data);
    } catch (e) {
      setError(
        e?.response?.data?.message ||
          e?.response?.data?.error ||
          e.message ||
          "Request failed",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="try-panel">
      <section className="doc-section">
        <h2>Try the API</h2>
        <p className="text-muted">
          Use a <strong>sandbox API key</strong> here. Sandbox writes go to an
          isolated schema — your production data is never touched.
        </p>

        <div className="form-group">
          <label>Sandbox API Key</label>
          <input
            type="password"
            className="form-control"
            placeholder="ivsg_key_..."
            value={apiKey}
            onChange={(e) => setApiKey(e.target.value)}
          />
        </div>

        <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
          <button
            className="btn btn-secondary"
            onClick={ping}
            disabled={loading || !apiKey}
          >
            {loading ? (
              <>
                <i className="fas fa-spinner fa-spin" /> Testing...
              </>
            ) : (
              <>
                <i className="fas fa-heartbeat" /> Test Connection
              </>
            )}
          </button>
          <button
            className="btn btn-primary"
            onClick={send}
            disabled={loading || !apiKey}
          >
            {loading ? (
              <>
                <i className="fas fa-spinner fa-spin" /> Sending...
              </>
            ) : (
              <>
                <i className="fas fa-paper-plane" /> Send POST
              </>
            )}
          </button>
        </div>

        <div className="form-group">
          <label>Request Body (JSON)</label>
          <textarea
            className="form-control doc-code-textarea"
            rows="12"
            value={payload}
            onChange={(e) => setPayload(e.target.value)}
            spellCheck={false}
          />
        </div>

        {error && (
          <div className="error-message">
            <i className="fas fa-exclamation-circle" /> {error}
          </div>
        )}

        {result && (
          <div className="try-result">
            <strong>Response</strong>
            <pre className="doc-code">
              <code>{JSON.stringify(result, null, 2)}</code>
            </pre>
          </div>
        )}
      </section>

      <section className="doc-section">
        <h2>Sandbox Notes</h2>
        <ul>
          <li>Sandbox data is isolated in its own schema.</li>
          <li>Production queries never see sandbox data.</li>
          <li>Sandbox data is auto-purged after 30 days.</li>
          <li>Sandbox rate limits are stricter (10/min).</li>
          <li>Webhooks are NOT fired for sandbox events.</li>
        </ul>
      </section>
    </div>
  );
}

export default TryPanel;